import React, { Component } from 'react';

class SideWrapping extends Component {
	render() {
        const {selectedWrapping} = this.props;
        return (
            <tr>
                <th>Side Wrapping</th>
                <td>{selectedWrapping.size > 0 ? selectedWrapping.getIn(['title', 'rendered']) : '-'}</td>
                <td>-</td>
            </tr>
        );
	}
}

export default SideWrapping;